import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { post } from '../../helpers/apiHelper';
import Swal from 'sweetalert2';

function FranquiciadoResetPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleResetPassword = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const data = await post('franquiciados-auth/forgot-password', { email });
            Swal.fire({
                icon: 'success',
                title: 'Correo enviado',
                text: data.message,
                confirmButtonColor: '#4F46E5',
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'No se pudo solicitar el restablecimiento',
                confirmButtonColor: '#EF4444',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full">
                <div className="text-center mb-8">
                    <Link to="/" className="inline-flex items-center space-x-3 mb-6">
                        <img src="/logos/logopng.png" alt="PetitPrime Logo" className="h-12 w-auto" />
                        <span className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                            PetitPrime
                        </span>
                    </Link>
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">Restablecer contraseña</h2>
                    <p className="text-gray-600">Introduce el email de tu cuenta de franquiciado</p>
                </div>

                <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
                    <form className="space-y-6" onSubmit={handleResetPassword}>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                Correo electrónico
                            </label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                className="block w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200"
                                placeholder="tu@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {loading ? 'Enviando...' : 'Enviar enlace de restablecimiento'}
                        </button>
                    </form>

                    <div className="mt-6">
                        <Link
                            to="/franquiciado/login"
                            className="w-full flex justify-center items-center py-3 px-4 border border-gray-300 rounded-xl shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-all duration-300"
                        >
                            Volver al login de franquiciado
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FranquiciadoResetPassword;
